import { render, staticRenderFns } from "./PathwayCohortViewHeader.vue?vue&type=template&id=63ca7db2&"
import script from "./PathwayCohortViewHeader.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports